import {setSystemToLowercase} from './shared/serverFunctions';

/**
 * VIP Signups
 */
export const RESOURCES = {
    "VIPSignups": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            let startEnd = params.start_date + "/" + params.end_date;
            //let startEndOffset = params.start_date + "/" + params.end_date + "/" + params.offset;
            return {
                "type": "list",
                "method": "GET",
                "title": "VIP Signups",
                "uri": localStorage.getItem('server') + "/api/v5/search/q/" + system + "/loyalty/registrationCountByLocation/" + startEnd
            }
        }
    }
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "VIPSignups"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseSearchResourceMap.js